import React, { useState, useEffect } from "react";
import Aux from "../../../hoc/Auxilliary";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
  Grid,
  IconButton,
} from "@material-ui/core/";
import { useDispatch, useSelector } from "react-redux";
import DeleteIcon from "@material-ui/icons/Delete";
import FormStyle from "./prospective.module.css";
import FormBuilder from "../../FormBuilder";
import {
  getTranscriptData,
  updateTranscriptData,
  deleteTranscriptRecord,
} from "../../../reduxSlices/applicationSlice";
import { validateApplicationForm } from "../../../helpers/validateApplicationForm";
import localizedStrings from "../../../utils/localize";
import FormHeader from "../../FormHeader";

const useStyles = makeStyles((theme) => ({
  TableControl: {
    display: "flex",
    flexDirection: "column",
  },
  formControl: {
    color: "white",
  },
  classConatiner: {
    padding: "1rem 0",
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  classHeaderFont: {
    fontSize: "1.1rem",
    fontWeight: 800,
    flex: 1,
  },
  classContentFont: {
    fontSize: "1rem",
    flex: 1,
  },
  formDesign: {
    width: "98%",
    margin: "0 auto",
  },
  addbutton: {
    paddingLeft: "32rem",
    [theme.breakpoints.down("lg")]: {
      paddingLeft: "24rem",
    },
    [theme.breakpoints.down("md")]: {
      paddingLeft: "12rem",
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "4rem",
    },
    [theme.breakpoints.down("xs")]: {
      paddingLeft: "4rem",
    },
  },
  bottomButtons: {
    paddingLeft: "27rem",
    [theme.breakpoints.down("lg")]: {
      paddingLeft: "24rem",
    },
    [theme.breakpoints.down("md")]: {
      paddingLeft: "15rem",
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "5rem",
    },
    [theme.breakpoints.down("xs")]: {
      paddingLeft: "1rem",
    },
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

var formJson = {};
const applicationpage = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles(props);

  const transcriptResultData = useSelector(
    (state) => state.applicationData.transcriptData,
  );

  const data = props?.transcriptJsonData || [];
  const [grade12, setGrade12] = useState(props.formData);
  const [displayGradeForm, setDisplayGradeForm] = useState(false);

  const [disabled, setDisabled] = useState(false);

  for (let key in grade12) {
    formJson[key] = grade12[key].value;
  }

  useEffect(() => {
    const newGrade12 = { ...grade12 };
    newGrade12.usb_otherclasscategory.display =
      props?.transcriptJsonData?.usb_classcategory === 943240034
        ? "block"
        : "none";
    setGrade12(newGrade12);
  }, [props?.transcriptJsonData]);

  useEffect(() => {
    if (props.applicationIdValue) {
      dispatch(getTranscriptData(props.applicationIdValue));
    }
  }, [props.applicationIdValue]);

  useEffect(() => {
    if (props.applicationIdValue) {
      const validateForm = validateApplicationForm(6, null, null, data);
      setDisabled(validateForm);
    }
  }, [data]);

  const textFieldChangeHandlerForApplication = (event, key) => {
    const updatedData = {
      ...props?.transcriptJsonData,
      [event.target.name]: event.target.value,
    };
    props.setTranscriptJsonData(updatedData);
  };

  const handleChangeforApplication = (event) => {
    const updatedData = {
      ...props?.transcriptJsonData,
      [event.target.name]: event.target.value,
    };
    props.setTranscriptJsonData(updatedData);
  };

  const handleDeleteGrade = (id) => {
    dispatch(deleteTranscriptRecord(id));
    setTimeout(() => {
      dispatch(getTranscriptData(props.applicationIdValue));
      props.setTranscriptJsonData(transcriptResultData);
    }, 2000);
  };

  const getLocalizedClassName = (classValue, localizedStrings) => {
    const localizedMapping = {
      943240000: localizedStrings.applicationpage.classes.advancedMathematics,
      943240001: localizedStrings.applicationpage.classes.appliedMathematics,
      943240002: localizedStrings.applicationpage.classes.canadianLaw,
      943240003: localizedStrings.applicationpage.classes.chemistry,
      943240004: localizedStrings.applicationpage.classes.cinemaModernHistory,
      943240005: localizedStrings.applicationpage.classes.computerScience,
      943240006: localizedStrings.applicationpage.classes.currentTopics,
      943240007: localizedStrings.applicationpage.classes.dance,
      943240008: localizedStrings.applicationpage.classes.dramaticArts,
      943240009: localizedStrings.applicationpage.classes.english,
      943240010: localizedStrings.applicationpage.classes.everydayMathematics,
      943240011: localizedStrings.applicationpage.classes.familyStudies,
      943240012: localizedStrings.applicationpage.classes.french,
      943240013: localizedStrings.applicationpage.classes.geography,
      943240014: localizedStrings.applicationpage.classes.globalIssues,
      943240015: localizedStrings.applicationpage.classes.guitar,
      943240016: localizedStrings.applicationpage.classes.harmony,
      943240017: localizedStrings.applicationpage.classes.history,
      943240018: localizedStrings.applicationpage.classes.introCalculus,
      943240019:
        localizedStrings.applicationpage.classes.introCalculusAdvancedMath,
      943240020: localizedStrings.applicationpage.classes.jazz,
      943240021: localizedStrings.applicationpage.classes.leadershipTraining,
      943240022: localizedStrings.applicationpage.classes.music,
      943240023: localizedStrings.applicationpage.classes.biology,
      943240024: localizedStrings.applicationpage.classes.philosophy,
      943240025: localizedStrings.applicationpage.classes.physicalEducation,
      943240026: localizedStrings.applicationpage.classes.physics,
      943240027:
        localizedStrings.applicationpage.classes.preCalculusMathematics,
      943240028: localizedStrings.applicationpage.classes.psychology,
      943240029: localizedStrings.applicationpage.classes.spanish,
      943240030: localizedStrings.applicationpage.classes.textileArtsDesign,
      943240031: localizedStrings.applicationpage.classes.visualArts,
      943240032: localizedStrings.applicationpage.classes.workLifeTransition,
      943240033: localizedStrings.applicationpage.classes.foodNutrition,
      943240034: localizedStrings.applicationpage.classes.other,
    };

    return localizedMapping[classValue] || "Unknown Class";
  };

  let tableData = "";

  if (data?.transcriptRecords) {
    tableData =
      data?.transcriptRecords?.length > 0
        ? data?.transcriptRecords?.map((element, index) => {
            return (
              <StyledTableRow key={index}>
                <StyledTableCell component="th" scope="row">
                  {getLocalizedClassName(
                    element.usb_classcategory,
                    localizedStrings,
                  )}
                  {element.usb_classcategory === 943240034 &&
                    ` - ${element["usb_otherclasscategory"]}`}
                </StyledTableCell>
                <StyledTableCell component="th" scope="row">
                  {
                    element[
                      "usb_level@OData.Community.Display.V1.FormattedValue"
                    ]
                  }
                </StyledTableCell>
                <StyledTableCell component="th" scope="row">
                  {
                    element[
                      "usb_grade@OData.Community.Display.V1.FormattedValue"
                    ]
                  }
                </StyledTableCell>
                <StyledTableCell>
                  <IconButton
                    color="secondary"
                    aria-label="delete"
                    onClick={() =>
                      handleDeleteGrade(element.usb_transcriptdataid)
                    }
                    component="span"
                  >
                    <DeleteIcon />
                  </IconButton>
                </StyledTableCell>
              </StyledTableRow>
            );
          })
        : null;
  }

  const addGrade = () => {
    setDisplayGradeForm(true);
    props.setDisabledNextValue(true);
    props.setDisabledSaveValue(true);
    props.setDisabledPrevValue(true);
  };

  const handleSaveGrade = () => {
    const transcriptData = {
      usb_classcategory: data.usb_classcategory,
      usb_otherclasscategory: data.usb_otherclasscategory,
      usb_level: data.usb_level,
      usb_grade: data.usb_grade,
    };
    dispatch(updateTranscriptData(transcriptData, props.applicationIdValue));
    setTimeout(() => {
      handleCancelGrade();
    }, 1600);
  };

  const handleCancelGrade = () => {
    setDisplayGradeForm(false);
    dispatch(getTranscriptData(props.applicationIdValue));
    props.setTranscriptJsonData(transcriptResultData);
    props.setDisabledNextValue(false);
    props.setDisabledSaveValue(false);
    props.setDisabledPrevValue(false);
  };
  return (
    <Aux>
      <Grid xs={12}>
        <Grid style={{ padding: "0 2.5rem" }}>
          <FormHeader name="Autodéclaration des notes de 12e année" />
          <Typography component="div" className={FormStyle.formContainer}>
            <div className={classes.formDesign}>
              {/* Header and Instructions */}
              {localizedStrings.applicationpage.instructionText}
              <Typography
                component="div"
                className={classes.classFont}
                style={{ marginTop: "1rem" }}
              >
                {localizedStrings.applicationpage.example}
                <br />
                {localizedStrings.applicationpage.instructions[0]}
                <br />
                {localizedStrings.applicationpage.instructions[1]}
                <br />
                {localizedStrings.applicationpage.instructions[2]}
                <br />
                {localizedStrings.applicationpage.instructions[3]}
                <br />
              </Typography>
              <br />
              {localizedStrings.applicationpage.labels.grade12Courses}
            </div>

            {/* Table for Courses */}
            <TableContainer
              component={Paper}
              style={{ minHeight: "40vh", marginBottom: "10px" }}
            >
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>
                      {localizedStrings.applicationpage.labels.classTitle}
                    </StyledTableCell>
                    <StyledTableCell>
                      {localizedStrings.applicationpage.labels.level}
                    </StyledTableCell>
                    <StyledTableCell>
                      {localizedStrings.applicationpage.labels.grade}
                    </StyledTableCell>
                    <StyledTableCell>
                      {localizedStrings.applicationpage.labels.deleteClass}
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>{tableData}</TableBody>
              </Table>
            </TableContainer>
            <br />

            {/* Add Class Button */}
            <Grid
              container
              justifyContent="center"
              spacing={2}
              className={classes.addbutton}
            >
              <Grid item>
                <Button variant="contained" color="primary" onClick={addGrade}>
                  {localizedStrings.applicationpage.labels.addClass}
                </Button>
                <br />
              </Grid>
            </Grid>

            {/* Form for Adding Grade */}
            {displayGradeForm && (
              <>
                <div style={{ margin: "0 1rem" }}>
                  <FormBuilder
                    formDetails={props.formData}
                    value={data}
                    handleChange={handleChangeforApplication}
                    changed={textFieldChangeHandlerForApplication}
                  />
                </div>
                <Grid
                  container
                  justifyContent="center"
                  spacing={2}
                  className={classes.bottomButtons}
                >
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleCancelGrade}
                    >
                      {localizedStrings.applicationpage.labels.cancelClass}
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSaveGrade}
                      disabled={disabled}
                    >
                      {localizedStrings.applicationpage.labels.saveClass}
                    </Button>
                  </Grid>
                  <br />
                </Grid>
              </>
            )}
          </Typography>
        </Grid>
      </Grid>
    </Aux>
  );
};

export default applicationpage;
